import React, { Component } from 'react'
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SvgNapoveda from '../../img/icons/Napoveda';
import { getLanguage } from '../../store/storeFunctions'
import { Translate } from 'react-localize-redux';

class HelpManager extends Component {
    render() {
        if(this.props.inMobileMenu) {
            return (
                <a key={this.props.itemKey} className='navbar-item' onClick={() => this.openNewHelpWindow()}>
                    <div className='icon-holder'><div className='icon-wrap'><SvgNapoveda /></div></div>
                    <div className='text-wrapper'><div className='text'><span className='span-wrapper'><Translate id='NavBar.Help' /></span></div></div>
                </a>
            );
        }

        return (
            <div key={this.props.itemKey} className={classnames('right-panel-icon', {'active':this.props.isActive})}
                onClick={() => this.openNewHelpWindow()}>
                <div className='right-panel-icon-wrapper'>
                    <div className='right-panel-icon-holder'>
                        <SvgNapoveda />
                    </div>
                </div>
            </div>
        )
    }

    openNewHelpWindow = () => {
        let candidate = ((this.props.layout || {}).helpMap || []).filter(x => x.regex !== null && x.regex !== undefined && new RegExp(x.regex).test(window.location.pathname));
        let sorted = candidate.sort(function(a,b){return a.page - b.page;});
        window.open('/help?page='+(sorted[0] || {page:-1}).page + '&lang='+getLanguage(), "_blank");
    }
}

export default connect(
    state => { return { layout: state.layout} },
    dispatch => bindActionCreators({}, dispatch)
)(HelpManager);
